import React, { Component } from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import { isEmpty, not } from 'ramda';
import { Map, is } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import { RedirectPage } from 'routes/routeNames';

import Error from 'components/ErrorMessage';
import CustomButton from 'components/CustomButton';
import TextField from 'components/TextField';
import Password from 'components/Password';
import loginUser from 'containers/Login/Login.actions';
import { loginSelector } from 'containers/Login/Login.redux';
// import { goto } from 'utils/navigation';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './Signin.scss';// to import local scss fle


export class Signin extends Component {


  static propTypes = {
    session: PropTypes.shape(),
    loginUser: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    push: PropTypes.func.isRequired,
    history: PropTypes.shape(),
    attributes: PropTypes.shape(), // eslint-disable-line
    errorMessage: PropTypes.string,
  };
  static defaultProps = {
    session: Map(),
    error: Map(),
    isLoading: false,
    history: {
      push: () => {},
    },
    attributes: {},
    errorMessage: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      userNameErrorMessage: '',
      passwordErrorMessage: '',
      username: '',
      password: '',
    };
    this.emailHandler = this.emailHandler.bind(this);
    this.passwordHandler = this.passwordHandler.bind(this);
    this.identifyEnter = this.identifyEnter.bind(this);
    this.login = this.login.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  // componentWillMount() {
  //   const { session = {} } = this.props;
  //       // this.props.loginUser('shasti@gmail.com', 'test123!');
  //   if (!session) {
  //     goto('');
  //   }
  // }

  componentWillReceiveProps(nextProps) {
    const { session = Map() } = this.props;
    if (nextProps.session && !is(nextProps.session, session) && !nextProps.session.isEmpty()) {
      this.props.history.push(RedirectPage);
    }
  }
  onFocus(name) {
    this.setState({ ...this.state, [name]: '' });
  }
  passwordHandler = (password) => {
    this.setState({ password });
  };

  login = () => {
    if (this.state.username !== '' && this.state.password !== '') {
      this.props.loginUser(this.state.username, this.state.password);
    } else if (this.state.username === '' && this.state.password === '') {
      this.setState({ userNameErrorMessage: 'Please enter a user name!', passwordErrorMessage: 'Please enter a password!' });
    } else if (this.state.username === '') {
      this.setState({ userNameErrorMessage: 'Please enter a user name!' });
    } else if (this.state.password === '') {
      this.setState({ passwordErrorMessage: 'Please enter a password!' });
    }
  };

  identifyEnter(e) {
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code === 13) { // Enter keycode
      if (this.state.username !== '' && this.state.password !== '') {
        this.login();
      } else if (this.state.username === '' && this.state.password === '') {
        this.setState({ userNameErrorMessage: 'Please enter a user name!', passwordErrorMessage: 'Please enter a password!' });
      } else if (this.state.username === '') {
        this.setState({ userNameErrorMessage: 'Please enter a user name!' });
      } else if (this.state.password === '') {
        this.setState({ passwordErrorMessage: 'Please enter a password!' });
      }
    }
  }

  emailHandler = (username) => {
    this.setState({ username });
  };

  render() {
    const { isLoading, errorMessage } = this.props;

      // Conditional rendering
    const renderIfLoading = renderIf(isLoading);
    const renderIfErrorIsNotEmpty = renderIf(not(isEmpty(errorMessage)));
    const renderIfNotLoading = renderIf(not(false));
    return (
      <div className={styles.signInContainer}>
        {renderIfLoading(
          <FullScreenLoader />,
          )}
        {renderIfErrorIsNotEmpty(
          <div className={styles.errorContainer}>
            <Error
              message={errorMessage}
            />
          </div>,
        )}

        {renderIfNotLoading(
          <div className={cn('row', styles.signInContainer)} >
            <TextField
              label="EMAIL"
              onChange={this.emailHandler}
              onKeyPress={this.identifyEnter}
              errorMessage={this.state.userNameErrorMessage}
              onFocus={() => this.onFocus('userNameErrorMessage')}
            />
            <Password
              onChange={this.passwordHandler}
              onKeyPress={this.identifyEnter}
              errorMessage={this.state.passwordErrorMessage}
              onFocus={() => this.onFocus('passwordErrorMessage')}
            />
            <CustomButton type="submit" onClick={this.login} />
          </div>)}
      </div>
    );
  }

}

export default connect(loginSelector, {
  loginUser,
})(Signin);



// WEBPACK FOOTER //
// ./src/components/Signin/Signin.js